<body>
  <div class="flex h-[calc(100dvh)] w-screen flex-col overflow-hidden">
    @defer (when appService.showConsole()) {
      @if (appService.showConsole()) {
        <bo-console class="z-[100]" />
      }
    }
    <ng-container>
      <router-outlet />
      @if (
        appService.currentView() === 'simulation' ||
        appService.currentView() === 'end' ||
        appService.currentView() === ''
      ) {
        <p
          class="bo-secondary absolute bottom-2 left-4 flex items-center"
          [ngClass]="
            appService.fullScreen() ? '!text-bo-white/50' : '!text-bo-black'
          "
        >
          © VirtaMed AG {{ date.getFullYear() }}, Rights reserved
          {{ versionInfo }}
        </p>
      }
    </ng-container>

    @if (appService.isPortraitMode()) {
      <p-dialog
        [visible]="appService.isPortraitMode() && !hidePortraitModeWarning()"
        [draggable]="false"
        [modal]="true"
        [style]="{ width: '80vw' }"
        (visibleChange)="hidePortraitModeWarning.set(true)"
      >
        <ng-template pTemplate="header">
          <p class="bo-title m-0">Wrong mode</p>
        </ng-template>
        <div class="bo-normal">
          <span>Use in landscape mode</span>
        </div>
      </p-dialog>
    }
  </div>
  <bo-scene-launcher />
</body>
